export const CUT_OFF_SCHEDULE = {
  SPECIFIC_DAY_EACH_MONTH: 'SPECIFIC_DAY_EACH_MONTH',
  TWICE_PER_MONTH: 'TWICE_PER_MONTH',
};

export const CUT_OFF_SECONDARY = {
  LAST_DAY: 'LAST_DAY',
  LAST_WORKING_DAY: 'LAST_WORKING_DAY',
};

export const CUT_OFF_DAY_MAX = 28;
